/* !!!!!!!!!!!!!!!!!!!!!!!!!!!
 Modified by Wargaming.net
 - Added CORS using XDomainRequest for IE9
 - Added classes when injections are clones of nodes or build on previously-downloaded data
 - Changed the duplicate detection to work on IMG tags as well as other elements (hopefully fixing a bug where some elements are injected with the wrong SVG)
 !!!!!!!!!!!!!!!!!!!!!!!!!!!
 */
/**
 * SVGInjector v1.1.3-RC - Fast, caching, dynamic inline SVG DOM injection library
 * https://github.com/iconic/SVGInjector
 *
 * Copyright (c) 2014 Waybury <hello@waybury.com>
 * @license MIT
 */

(function (window, document) {

    'use strict';

    // Environment
    var isLocal = window.location.protocol === 'file:';
    var hasSvgSupport = document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');

    function uniqueClasses(list) {
        list = list.split(' ');

        var hash = {};
        var i = list.length;
        var out = [];

        while (i--) {
            if (!hash.hasOwnProperty(list[i])) {
                hash[list[i]] = 1;
                out.unshift(list[i]);
            }
        }

        return out.join(' ');
    }

    function finalizeInjectedNode(clone, typeOfInjection) {
        clone.setAttribute('class', clone.getAttribute('class') + ' ' + typeOfInjection);
        
        // Title attributes on SVG root elements do not show as tooltips in at least Chrome.
        // To get around this, if a title attribute is detected on the element, it is injected
        // as a rect with a title element within.
        
        var title = clone.getAttribute('title');
        if (title) {
            var titleNode = document.createElementNS('http://www.w3.org/2000/svg', 'title');
            var titleContainer = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            titleNode.appendChild(document.createTextNode(title));
            titleContainer.setAttribute('x','0');
            titleContainer.setAttribute('y','0');
            titleContainer.setAttribute('width','100%');
            titleContainer.setAttribute('height','100%');
            titleContainer.setAttribute('style','fill:transparent !important;');
            titleContainer.appendChild(titleNode);
            clone.appendChild(titleContainer);
        }
    }

    // Create the XHR object.
    function createCORSRequest(method, url) {
        var xhr = new XMLHttpRequest();
        if ('withCredentials' in xhr) {
            // XHR for Chrome/Firefox/Opera/Safari.
            xhr.open(method, url, true);
        } else if (typeof XDomainRequest !== 'undefined') {
            // XDomainRequest for IE.
            xhr = new XDomainRequest();
            xhr.open(method, url);
        } else {
            // CORS not supported.
            xhr = null;
        }
        return xhr;
    }

    /**
     * cache (or polyfill for <= IE8) Array.forEach()
     * source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
     */
    var forEach = Array.prototype.forEach || function (fn, scope) {
            if (this === void 0 || this === null || typeof fn !== 'function') {
                throw new TypeError();
            }

            /* jshint bitwise: false */
            var i, len = this.length >>> 0;
            /* jshint bitwise: true */

            for (i = 0; i < len; ++i) {
                if (i in this) {
                    fn.call(scope, this[i], i, this);
                }
            }
        };

    // SVG Cache
    var svgCache = {};

    var injectCount = 0;
    var injectedElements = [];

    // Request Queue
    var requestQueue = [];

    // Script running status
    var ranScripts = {};

    var cloneSvg = function (sourceSvg) {
        return sourceSvg.cloneNode(true);
    };

    var queueRequest = function (url, callback) {
        requestQueue[url] = requestQueue[url] || [];
        requestQueue[url].push(callback);
    };

    var processRequestQueue = function (url) {
        for (var i = 0, len = requestQueue[url].length; i < len; i++) {
            // Make these calls async so we avoid blocking the page/renderer
            /* jshint loopfunc: true */
            (function (index) {
                setTimeout(function () {
                    var clone = cloneSvg(svgCache[url]);
                    requestQueue[url][index](clone);
                    finalizeInjectedNode(clone, 'waited-for-data-clone-injection');
                }, 0);
            })(i);
            /* jshint loopfunc: false */
        }
    };

    var loadSvg = function (url, callback) {
        if (svgCache[url] !== undefined) {
            if (svgCache[url] instanceof SVGSVGElement) {
                // We already have it in cache, so use it
                var clonedNode = cloneSvg(svgCache[url]);
                finalizeInjectedNode(clonedNode, 'existing-data-clone-injection');
                callback(clonedNode);
            }
            else {
                // We don't have it in cache yet, but we are loading it, so queue this request
                queueRequest(url, callback);
            }
        }
        else {

            if (!window.XMLHttpRequest) {
                callback('Browser does not support XMLHttpRequest');
                return false;
            }

            // Seed the cache to indicate we are loading this URL already
            svgCache[url] = {};
            queueRequest(url, callback);

            var xhr = createCORSRequest('GET', url);

            if (xhr === null) {
                callback('Browser does not support CORS');
                return false;
            }

            var isOldCORS = (typeof XDomainRequest !== 'undefined' && xhr instanceof XDomainRequest);

            if (isOldCORS) {
                /* http://stackoverflow.com/questions/8058446/ie-xdomainrequest-not-always-work */
                xhr.onprogress = function () {
                };
                xhr.onerror = function () {
                };
                xhr.ontimeout = function () {
                };
            }

            xhr[isOldCORS ? 'onload' : 'onreadystatechange'] = function () {
                // readyState 4 = complete
                if (xhr.readyState === 4 || isOldCORS) {

                    // Handle status
                    if (xhr.status === 404 || xhr.responseXML === null) {
                        callback('Unable to load SVG file: ' + url);

                        if (isLocal) callback('Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver.');

                        callback();
                        return false;
                    }

                    // 200 success from server, or 0 when using file:// protocol locally
                    if (xhr.status === 200 || (isLocal && xhr.status === 0) || isOldCORS) {

                        /* globals Document */
                        if (xhr.responseXML instanceof Document) {
                            // Cache it
                            svgCache[url] = xhr.responseXML.documentElement;
                        }
                        /* globals -Document */

                        // IE9 doesn't create a responseXML Document object from loaded SVG,
                        // and throws a "DOM Exception: HIERARCHY_REQUEST_ERR (3)" error when injected.
                        //
                        // So, we'll just create our own manually via the DOMParser using
                        // the the raw XML responseText.
                        //
                        // :NOTE: IE8 and older doesn't have DOMParser, but they can't do SVG either, so...
                        else if (DOMParser && (DOMParser instanceof Function)) {
                            var xmlDoc;
                            try {
                                var parser = new DOMParser();
                                xmlDoc = parser.parseFromString(xhr.responseText, 'text/xml');
                            }
                            catch (e) {
                                xmlDoc = undefined;
                            }

                            if (!xmlDoc || xmlDoc.getElementsByTagName('parsererror').length) {
                                callback('Unable to parse SVG file: ' + url);
                                return false;
                            }
                            else {
                                // Cache it
                                svgCache[url] = xmlDoc.documentElement;
                            }
                        }

                        // We've loaded a new asset, so process any requests waiting for it
                        processRequestQueue(url);
                    }
                    else {
                        callback('There was a problem injecting the SVG: ' + xhr.status + ' ' + xhr.statusText);
                        return false;
                    }
                }
            };

            // Treat and parse the response as XML, even if the
            // server sends us a different mimetype
            if (xhr.overrideMimeType) xhr.overrideMimeType('text/xml');

            xhr.send();
        }
    };

    // Inject a single element
    var injectElement = function (el, evalScripts, pngFallback, callback) {

        // If this is an SVG, we've already loaded it and there's no reaon to load it again
        if (el.nodeName.toLowerCase() == 'svg')
            return;

        // Grab the src or data-src attribute
        var imgUrl = el.getAttribute('data-src') || el.getAttribute('src');

        // We may have already processed an identical SVG; if so, let's not do it again. Even if we don't find one with
        // the same classes, the download might still be skipped later inside loadSvg
        var svgs = document.querySelectorAll('svg.injected-svg');
        for (var i = 0; i < svgs.length; i++) {
            var svg = svgs[i];
            if (imgUrl == svg.getAttribute('data-src') &&
                ('injected-svg ' + el.getAttribute('class')) == svg.getAttribute('class')) {
                var clone = svg.cloneNode(true);
                el.parentNode.replaceChild(clone, el);
                finalizeInjectedNode(clone, 'node-clone-injection');
                callback(clone);
                return;
            }
        }


        // We can only inject SVG
        if (!(/\.svg/i).test(imgUrl)) {
            callback('Attempted to inject a file with a non-svg extension: ' + imgUrl);
            return;
        }

        // If we don't have SVG support try to fall back to a png,
        // either defined per-element via data-fallback or data-png,
        // or globally via the pngFallback directory setting
        if (!hasSvgSupport) {
            var perElementFallback = el.getAttribute('data-fallback') || el.getAttribute('data-png');

            // Per-element specific PNG fallback defined, so use that
            if (perElementFallback) {
                el.setAttribute('src', perElementFallback);
                callback(null);
            }
            // Global PNG fallback directoriy defined, use the same-named PNG
            else if (pngFallback) {
                el.setAttribute('src', pngFallback + '/' + imgUrl.split('/').pop().replace('.svg', '.png'));
                callback(null);
            }
            // um...
            else {
                callback('This browser does not support SVG and no PNG fallback was defined.');
            }

            return;
        }

        // Make sure we aren't already in the process of injecting this element to
        // avoid a race condition if multiple injections for the same element are run.
        // :NOTE: Using indexOf() only _after_ we check for SVG support and bail,
        // so no need for IE8 indexOf() polyfill
        if (injectedElements.indexOf(el) !== -1) {
            return;
        }

        // Remember the request to inject this element, in case other injection
        // calls are also trying to replace this element before we finish
        injectedElements.push(el);

        // Try to avoid loading the orginal image src if possible.
        el.setAttribute('src', '');

        // Load it up
        loadSvg(imgUrl, function (svg) {

            if (typeof svg === 'undefined' || typeof svg === 'string') {
                callback(svg);
                return false;
            }

            var imgId = el.getAttribute('id');
            if (imgId) {
                svg.setAttribute('id', imgId);
            }

            var imgTitle = el.getAttribute('title');
            if (imgTitle) {
                svg.setAttribute('title', imgTitle);
            }

            // Concat the SVG classes + 'injected-svg' + the img classes
            var classMerge = [].concat(svg.getAttribute('class') || [], 'injected-svg', el.getAttribute('class') || []).join(' ');
            svg.setAttribute('class', uniqueClasses(classMerge));
            svg.setAttribute('data-src', imgUrl);

            var imgStyle = el.getAttribute('style');
            if (imgStyle) {
                svg.setAttribute('style', imgStyle);
            }

            // Copy all the data elements to the svg
            var imgData = [].filter.call(el.attributes, function (at) {
                return (/^data-\w[\w\-]*$/).test(at.name);
            });
            forEach.call(imgData, function (dataAttr) {
                if (dataAttr.name && dataAttr.value) {
                    svg.setAttribute(dataAttr.name, dataAttr.value);
                }
            });

            // Make sure any internally referenced clipPath ids and their
            // clip-path references are unique.
            //
            // This addresses the issue of having multiple instances of the
            // same SVG on a page and only the first clipPath id is referenced.
            //
            // Browsers often shortcut the SVG Spec and don't use clipPaths
            // contained in parent elements that are hidden, so if you hide the first
            // SVG instance on the page, then all other instances lose their clipping.
            // Reference: https://bugzilla.mozilla.org/show_bug.cgi?id=376027
            var clipPaths = svg.querySelectorAll('defs clipPath[id]');
            var newClipPathName;
            for (var g = 0, clipPathsLen = clipPaths.length; g < clipPathsLen; g++) {
                newClipPathName = clipPaths[g].id + '-' + injectCount;
                // :NOTE: using a substring match attr selector here to deal with IE "adding extra quotes in url() attrs"
                var usingClipPath = svg.querySelectorAll('[clip-path*="' + clipPaths[g].id + '"]');
                for (var h = 0, usingClipPathLen = usingClipPath.length; h < usingClipPathLen; h++) {
                    usingClipPath[h].setAttribute('clip-path', 'url(#' + newClipPathName + ')');
                }
                clipPaths[g].id = newClipPathName;
            }

            // Do the same for masks
            var masks = svg.querySelectorAll('defs mask[id]');
            var newMaskName;
            for (var i = 0, masksLen = masks.length; i < masksLen; i++) {
                newMaskName = masks[i].id + '-' + injectCount;
                // :NOTE: using a substring match attr selector here to deal with IE "adding extra quotes in url() attrs"
                var usingMask = svg.querySelectorAll('[mask*="' + masks[i].id + '"]');
                for (var j = 0, usingMaskLen = usingMask.length; j < usingMaskLen; j++) {
                    usingMask[j].setAttribute('mask', 'url(#' + newMaskName + ')');
                }
                masks[i].id = newMaskName;
            }

            // Remove any unwanted/invalid namespaces that might have been added by SVG editing tools
            svg.removeAttribute('xmlns:a');

            // Post page load injected SVGs don't automatically have their script
            // elements run, so we'll need to make that happen, if requested

            // Find then prune the scripts
            var scripts = svg.querySelectorAll('script');
            var scriptsToEval = [];
            var script, scriptType;

            for (var k = 0, scriptsLen = scripts.length; k < scriptsLen; k++) {
                scriptType = scripts[k].getAttribute('type');

                // Only process javascript types.
                // SVG defaults to 'application/ecmascript' for unset types
                if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript') {

                    // innerText for IE, textContent for other browsers
                    script = scripts[k].innerText || scripts[k].textContent;

                    // Stash
                    scriptsToEval.push(script);

                    // Tidy up and remove the script element since we don't need it anymore
                    svg.removeChild(scripts[k]);
                }
            }

            // Run/Eval the scripts if needed
            if (scriptsToEval.length > 0 && (evalScripts === 'always' || (evalScripts === 'once' && !ranScripts[imgUrl]))) {
                for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {

                    // :NOTE: Yup, this is a form of eval, but it is being used to eval code
                    // the caller has explictely asked to be loaded, and the code is in a caller
                    // defined SVG file... not raw user input.
                    //
                    // Also, the code is evaluated in a closure and not in the global scope.
                    // If you need to put something in global scope, use 'window'
                    new Function(scriptsToEval[l])(window); // jshint ignore:line
                }

                // Remember we already ran scripts for this svg
                ranScripts[imgUrl] = true;
            }

            // :WORKAROUND:
            // IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
            // This trick will trigger IE to read and use any existing SVG <style> tags.
            //
            // Reference: https://github.com/iconic/SVGInjector/issues/23
            var styleTags = svg.querySelectorAll('style');
            forEach.call(styleTags, function (styleTag) {
                styleTag.textContent += '';
            });

            // Replace the image with the svg
            el.parentNode.replaceChild(svg, el);

            // Now that we no longer need it, drop references
            // to the original element so it can be GC'd
            delete injectedElements[injectedElements.indexOf(el)];
            el = null;

            // Increment the injected count
            injectCount++;

            callback(svg);
        });
    };

    /**
     * SVGInjector
     *
     * Replace the given elements with their full inline SVG DOM elements.
     *
     * :NOTE: We are using get/setAttribute with SVG because the SVG DOM spec differs from HTML DOM and
     * can return other unexpected object types when trying to directly access svg properties.
     * ex: "className" returns a SVGAnimatedString with the class value found in the "baseVal" property,
     * instead of simple string like with HTML Elements.
     *
     * @param {mixes} Array of or single DOM element
     * @param {object} options
     * @param {function} callback
     * @return {object} Instance of SVGInjector
     */
    var SVGInjector = function (elements, options, done) {

        // Options & defaults
        options = options || {};

        // Should we run the scripts blocks found in the SVG
        // 'always' - Run them every time
        // 'once' - Only run scripts once for each SVG
        // [false|'never'] - Ignore scripts
        var evalScripts = options.evalScripts || 'always';

        // Location of fallback pngs, if desired
        var pngFallback = options.pngFallback || false;

        // Callback to run during each SVG injection, returning the SVG injected
        var eachCallback = options.each;

        // Do the injection...
        if (elements.length !== undefined) {
            var elementsLoaded = 0;
            forEach.call(elements, function (element) {
                injectElement(element, evalScripts, pngFallback, function (svg) {
                    if (eachCallback && typeof eachCallback === 'function') eachCallback(svg);
                    if (done && elements.length === ++elementsLoaded) done(elementsLoaded);
                });
            });
        }
        else {
            if (elements) {
                injectElement(elements, evalScripts, pngFallback, function (svg) {
                    if (eachCallback && typeof eachCallback === 'function') eachCallback(svg);
                    if (done) done(1);
                    elements = null;
                });
            }
            else {
                if (done) done(0);
            }
        }
    };

    module.exports = {
        SVGInjector: SVGInjector
    };

}(window, document));
